// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "7cdd6eea99c21e3f5a77ec503402fb2d" + ".js";
};